module.exports = __webpack_public_path__ + "img/28_13.862d69f6.png";